import { getCountryFromLocale, getLanguageFromLocale } from "./locale";

describe("getCountryFromLocale", () => {
    it("should return the country", () => {
        expect(getCountryFromLocale("de-DE")).toBe("DE");
    });

    it("should return null if no country is present", () => {
        expect(getCountryFromLocale("de")).toBe(null);
    });
});

describe("getLanguageFromLocale", () => {
    it("should return the language", () => {
        expect(getLanguageFromLocale("de-DE")).toBe("de");
    });

    it("should return the locale if no country is present", () => {
        expect(getLanguageFromLocale("de")).toBe("de");
    });
});
